/* eslint-disable import/no-restricted-paths */
import { CombinedState, EnhancedStore, PreloadedState } from '@reduxjs/toolkit';

import { type TPageType, type IAppContext } from '../types/applicationContext';
import { createSubsidizedCalculatorStore } from '../../subsidizedCalculator/redux/';
import { createOfferCalculatorStore } from '../../offerCalculator/redux/';
import { createMortgageMiniCalculatorStore } from '../../mortgageMiniCalculator/redux';

export const mapPageTypeToCreateStoreFunction = {
  subsidizedCalculator: createSubsidizedCalculatorStore,
  offerCalculator: createOfferCalculatorStore,
  mortgageMiniCalculator: createMortgageMiniCalculatorStore,
} satisfies Record<TPageType, TCreateStoreFunctionSignature>;

export type TCreateStoreFunctionSignature = (
  context: IAppContext,
  preloadedState: PreloadedState<CombinedState<unknown>>,
  debugEnabled: boolean,
) => EnhancedStore;

export type TGenericStore<PAGE_TYPE extends TPageType = TPageType> = ReturnType<
  (typeof mapPageTypeToCreateStoreFunction)[PAGE_TYPE]
>;

export type TGenericStoreState<PAGE_TYPE extends TPageType = TPageType> = ReturnType<
  TGenericStore<PAGE_TYPE>['getState']
>;
